import { render, staticRenderFns } from "./Believe.vue?vue&type=template&id=d2ab1d66&scoped=true"
import script from "./Believe.vue?vue&type=script&lang=ts"
export * from "./Believe.vue?vue&type=script&lang=ts"
import style0 from "./Believe.vue?vue&type=style&index=0&id=d2ab1d66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ab1d66",
  null
  
)

export default component.exports